import {getRegionList, getWoredaByZoneId, getZoneByRegionId} from "@/utils/helper";

export default {
    data() {
        return {
            birthPlaceLookupLoading: false,
            BIRTH_REGIONS: [],
            BIRTH_ZONES: [],
            BIRTH_WOREDAS: [],
        };
    },
    methods: {
        async loadBirthPlaceLookups() {
            this.birthPlaceLookupLoading = true;
            this.BIRTH_REGIONS = await getRegionList() || [];
            await this.syncBirthPlaceLookups();
            this.birthPlaceLookupLoading = false;
        },
        async syncBirthPlaceLookups() {
            const regionId = this.formValues?.birthRegionId;
            const zoneId = this.formValues?.birthZoneId;

            this.BIRTH_ZONES = regionId ? (await getZoneByRegionId(regionId)) || [] : [];
            this.BIRTH_WOREDAS = zoneId ? (await getWoredaByZoneId(zoneId)) || [] : [];
        },
        async onBirthRegionChange(regionId, options = {}) {
            const {preserveSelection = false} = options;
            this.BIRTH_ZONES = [];
            this.BIRTH_WOREDAS = [];

            if (!preserveSelection) {
                this.formValues.birthZoneId = null;
                this.formValues.birthWoredaId = null;
            }

            if (!regionId) {
                return;
            }

            this.BIRTH_ZONES = await getZoneByRegionId(regionId) || [];
        },
        async onBirthZoneChange(zoneId, options = {}) {
            const {preserveSelection = false} = options;
            this.BIRTH_WOREDAS = [];

            if (!preserveSelection) {
                this.formValues.birthWoredaId = null;
            }

            if (!zoneId) {
                return;
            }

            this.BIRTH_WOREDAS = await getWoredaByZoneId(zoneId) || [];
        },
    },
};
